module.exports = __webpack_public_path__ + "img/15.4b2dcd21.png";